import { useEffect, useState } from "react";

import BasicDropdown from "../../../ui library/components/dropdowns/BasicDropdown";
import { tableSelectProps } from "../utils/styles";

export default function Source({ initValue, repository, onChange, isTableView = false }) {
  const [data, setData] = useState([]);

  const parseData = (items) =>
    items.map((item) => ({
      id: item.key,
      key: item.key,
      label: item.label,
    }));

  useEffect(() => {
    const fetchData = async () => {
      const response = await repository.query({
        content_type: "providerreferral",
        field_name: "source",
      });
      const mapped = parseData(response);
      setData(mapped);
    };

    fetchData().catch((error) => console.error(error));
  }, [repository]);

  return (
    <BasicDropdown
      initValue={initValue}
      label={isTableView ? "" : "Source"}
      data={data}
      onValueChange={(_, value) => {
        onChange("source", value);
      }}
      addNoSelectionOption={true}
      selectProps={isTableView ? tableSelectProps : {}}
    />
  );
}
